import React, { useState, useEffect } from 'react';
import ImageWithFallback from './ImageWithFallback';

const HeroSection = ({ images }) => {
  const [heroImage, setHeroImage] = useState(null);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    // Get daily hero image based on the date
    const getDailyImage = () => {
      const today = new Date();
      const dayOfYear = Math.floor((today - new Date(today.getFullYear(), 0, 0)) / 1000 / 60 / 60 / 24);
      const index = dayOfYear % images.length;
      return images[index];
    };

    setHeroImage(getDailyImage());
    setImageError(false);
  }, [images]);

  // If image fails to load, try the next one
  useEffect(() => {
    if (imageError && images.length > 1) {
      const currentIndex = images.findIndex(img => img.url === heroImage?.url);
      const nextIndex = (currentIndex + 1) % images.length;
      setHeroImage(images[nextIndex]);
      setImageError(false);
    }
  }, [imageError, heroImage, images]);

  if (!heroImage) return null;

  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Hero Image */}
      <div className="absolute inset-0 bg-gray-900">
        <ImageWithFallback
          src={heroImage.url}
          alt={heroImage.alt}
          className="absolute inset-0 w-full h-full object-cover animate-fade-in"
          onError={() => setImageError(true)}
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50" />
      </div>

      {/* Hero Content */}
      <div className="relative h-full flex flex-col items-center justify-center text-white px-4">
        <h1 className="text-6xl md:text-8xl font-bold mb-4 animate-slide-up text-center drop-shadow-2xl">
          Chia
        </h1>
        <p className="text-2xl md:text-4xl mb-8 animate-slide-up text-center drop-shadow-lg font-light">
          Therapy Dog
        </p>
        <div className="animate-slide-up delay-200">
          <p className="text-lg md:text-xl text-center max-w-2xl drop-shadow-md">
            Bringing joy, comfort, and unconditional love to those who need it most
          </p>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg 
          className="w-8 h-8 text-white drop-shadow-lg" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M19 14l-7 7m0 0l-7-7m7 7V3" 
          />
        </svg>
      </div>
    </div>
  );
};

export default HeroSection;

